module.exports = __webpack_public_path__ + "img/report-1.9b5eac35.jpg";